import { Feature, PermanentFeature } from "~/shared/util/feature"
import viewManager from "~/shared/util/viewManager"

export { Feature, PermanentFeature }

export function isFeatureEnabled(feature: Feature | PermanentFeature): boolean {
  return viewManager.get("features")[feature]
}
